import React from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';

import Accordion from 'react-bootstrap/Accordion';

import { MainRoutes, ReportRoutes } from 'helpers/routes';
import useReports from 'hooks/useReports';
import Labels from 'utils/labels';
import { FlexColumn } from 'resources/styles/display';

import {
  AccordionHeader,
  AccordionBody,
  AccordionItem,
  activeStyle,
  Menu,
  MenuItem,
} from './styles';

const ReportViewMenu = () => {
  const { currentUser, hasWorkSpace, reports } = useReports();
  const { pathname, search } = useLocation();
  const { reportId } = useParams();

  const isHome = React.useMemo(
    () => pathname === `${MainRoutes.REPORTS}/${ReportRoutes.VIEW}`,
    [pathname],
  );

  const currentUserReports = React.useMemo(
    () => (reports.userId === currentUser?.id ? reports.data : []),
    [currentUser?.id, reports],
  );

  return (
    <FlexColumn style={{ gap: '2rem' }}>
      <Menu>
        <Accordion defaultActiveKey={reportId ? '0' : null} flush>
          <MenuItem
            as={NavLink}
            replace
            style={() => (isHome ? activeStyle : undefined)}
            to={{
              pathname: `${MainRoutes.REPORTS}/${ReportRoutes.VIEW}`,
              search,
            }}
          >
            Home
          </MenuItem>

          <AccordionItem eventKey="0">
            <AccordionHeader>Dashboards</AccordionHeader>
            <AccordionBody>
              {currentUserReports
                .filter((x) => x.group === 'Dashboards')
                ?.map(({ id, name }) => (
                  <MenuItem
                    as={NavLink}
                    key={name}
                    replace
                    style={({ isActive }) => (isActive ? activeStyle : undefined)}
                    to={{
                      pathname: `${MainRoutes.REPORTS}/${ReportRoutes.VIEW}/${id}`,
                      search,
                    }}
                  >
                    {name}
                  </MenuItem>
                ))}
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </Menu>
      {hasWorkSpace && (
        <MenuItem
          as={NavLink}
          replace
          target="_blank"
          to={{
            pathname: `${MainRoutes.REPORTS}/${ReportRoutes.VIEW}/workspace`,
            search,
          }}
        >
          {Labels.workspace}
        </MenuItem>
      )}
    </FlexColumn>
  );
};

export default ReportViewMenu;
